import { Component, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

import { DefaultEditor } from './default-editor';

@Component({
  selector: 'input-editor',
  styleUrls: ['./editor.component.scss'],
  template: `
    <ng-template #customToolTip
      ><div [innerHtml]="cell.getToolTip() | translate"></div
    ></ng-template>
    <input
      [ngClass]="inputClass"
      class="form-control"
      [formControl]="formControl"
      [name]="cell.getId()"
      [placeholder]="cell.getTitle()"
      (click)="onClick.emit($event)"
      (blur)="blur.emit($event)"
      (keydown.enter)="onEdited.emit($event)"
      [tooltip]="customToolTip"
      [isDisabled]="!cell.getToolTip()"
      maxlength="{{ cell.getMaxLength() }}"
    />
  `,
  standalone: false
})
export class InputEditorComponent extends DefaultEditor {
  get formControl(): FormControl {
    return this.cell.getValidator() as FormControl;
  }
  @Output() public blur = new EventEmitter<any>();
  constructor() {
    super();
  }
}